import React, { useEffect, useState } from 'react'
import Webcam from 'react-webcam';
import { useMediaQuery } from '@mui/material';
import { B64toBlob } from '../../utils'

export const CustomCameraSelfie = props => {
  const webcamRef = React.createRef()
  const matches320 = useMediaQuery('(max-width: 320px)')
  const matches414 = useMediaQuery('(max-width: 414px)')
  const size = useWindowSize();
  const isMobile = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) ? true : false

  //console.log('SIZE: ', size)

  const capture = React.useCallback(() => {
    // let base64 = webcamRef.current.getScreenshot();
    let base64 = navigator.userAgent.match(/Android/i) ?
      webcamRef.current.getScreenshot({ width: 960, height: 1280 })
      : navigator.userAgent.match(/iPhone/i) ?
        matches320 ?
          webcamRef.current.getScreenshot({ width: 1280, height: 1365 })
          : matches414 ?
            webcamRef.current.getScreenshot({ width: 1280, height: 1365 })
            : webcamRef.current.getScreenshot({ width: 1280, height: 1707 })
        : props.Redimensionar ? webcamRef.current.getScreenshot({ width: 960, height: 720 })
          : webcamRef.current.getScreenshot();

    //console.log("imageSrc CustomCameraSelfie base64: ", base64)
    if (base64 != null && base64 != undefined) {
      base64 = base64.split(',')
      const blob = B64toBlob(base64[1], 'image/jpeg');
      props.onCapture(blob)
    }
  }, [webcamRef]);
  

  useEffect(() => {
    if (props.CaptureInit == true) {
      capture()
    }
  }, [props.CaptureInit])

  return (<>
    <Webcam
      onUserMediaError={(e) => {
        //console.log("***********onUserMediaError camera.*************", e)
        window.reload()
      }}
      onError={(e) => {
        // console.log("***********onError camera.*************", e)
        window.reload()
      }}
      audio={false}
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      screenshotQuality={1}
      style={props.isDisplay === false ? { display: 'none', width: "100%",
          height: isMobile ? "60vh" : "auto",
          borderRadius: "12px", } : { display: 'block', width: "100%",
          height: isMobile ? "60vh" : "auto",
          borderRadius: "12px", }}
      videoConstraints={{ facingMode: 'user', echoCancellation: true, noiseSuppression: true }}
      mirrored={false/* navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/Android/i) ? true : false */
      }
    />
  </>);
}

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}